import React, { Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import Loader from "../components/Loader";

const Indoor = React.lazy(() => import("../pages/IndoorEntry"));
const Code = React.lazy(() => import("../pages/Code"));
const Reset = React.lazy(() => import("../pages/Reset"));
const Vertical = React.lazy(() => import("../pages/Vertical"));

export const router = createBrowserRouter([
  {
    path: "/indoor",
    element: (
      <Suspense fallback={<Loader />}>
        <Indoor />
      </Suspense>
    ),
  },
  {
    path: "/reset",
    element: (
      <Suspense fallback={<Loader />}>
        <Reset />
      </Suspense>
    ),
  },
  {
    path: "/code/:code",
    element: (
      <Suspense fallback={<Loader />}>
        <Code />
      </Suspense>
    ),
  },
  {
    path: "/v/:rotation",
    element: (
      <Suspense fallback={<Loader />}>
        <Vertical />
      </Suspense>
    ),
  },
  {
    path: "*",
    element: (
      <Suspense fallback={<Loader />}>
        <Indoor />
      </Suspense>
    ),
  },
]);
